// render Stripe payment fields
import React, { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

// style Stripe fields
const stripeElementOptions = {
  style: {
    base: {
      color: "rgba(42, 57, 61, 1)",
      fontWeight: "400",
      fontFamily: "Overpass, sans-serif",
      fontSize: "16px",
      "::placeholder": {
        color: "rgba(42, 57, 61, .5)",
      },
    },
    invalid: {
      iconColor: "rgba(221, 85, 85, 1)",
      color: "rgba(221, 85, 85, 1)",
    },
  },
};

const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const SavedCardOption = (props) => {
  if (props.card?.last4) {
    return (
      <div className="method-existing">
        <div className="method-selector">
          <input
            type="radio"
            id="existingMethod"
            checked={props.chosenMethod === "saved"}
            onChange={props.handleChosenMethodSaved}
          />{" "}
          <label htmlFor="existingMethod">
            {capitalize(props.card.brand)} ending {props.card.last4}
          </label>
        </div>
        <div className="method-logos">
          <img
            alt={capitalize(props.card.brand)}
            src={`/assets/img/logo-${props.card.brand}.svg`}
          />
        </div>
      </div>
    );
  }
};

const PaymentMethodFields = (props) => {
  const [savedCard, setSavedCard] = useState(null);
  useEffect(() => {
    if (props.savedBilling && props.savedBilling.length != 0) {
      if (Object.keys(props.savedBilling.card).length == 0) {
        setSavedCard(null);
      } else {
        setSavedCard(props.savedBilling.card);
      }
    } else {
      setSavedCard(null);
    }
  }, [props.savedBilling]);

  const { register, formState } = useFormContext();
  return (
    <div className="component-payment-method-fields">
      {savedCard && (
        <SavedCardOption
          chosenMethod={props.chosenMethod}
          handleChosenMethodSaved={props.handleChosenMethodSaved}
          card={savedCard}
        />
      )}

      <div className={savedCard ? "method-new" : "method-solo"}>
        {savedCard && (
          <div className="method-selector">
            <input
              type="radio"
              id="newMethod"
              checked={props.chosenMethod === "new"}
              onChange={props.handleChosenMethodNew}
            />{" "}
            <label htmlFor="newMethod">New credit card</label>
          </div>
        )}

        <div className="method-logos">
          <img alt="Visa" src="/assets/img/logo-visa.svg" />
          <img alt="Mastercard" src="/assets/img/logo-mastercard.svg" />
          <img alt="American Express" src="/assets/img/logo-amex.svg" />
          <img alt="Discover" src="/assets/img/logo-discover.svg" />
        </div>
        <div className="field">
          <CardNumberElement
            id="stripeCardNumber"
            className="stripe-card-number"
            options={stripeElementOptions}
          />
        </div>
        <div className="field">
          <input
            id="billing_name"
            type="text"
            placeholder=" "
            {...register("billing_name", {
              required: true,
            })}
            className={
              "billing-name " + (formState.errors.billing_name && "error") ||
              (formState.dirtyFields.billing_name && "valid")
            }
          />
          <label htmlFor="billing_name">Name on card</label>
          <div className="field-error-msg">
            {formState?.errors?.billing_name?.type === "required" &&
              "Please enter the name on your credit card"}
          </div>
        </div>
        <div className="fieldset">
          <CardExpiryElement
            id="stripeCardExpiry"
            className="stripe-card-expiry"
            options={stripeElementOptions}
          />
          <CardCvcElement
            id="stripeCardCvc"
            className="stripe-card-cvc"
            options={stripeElementOptions}
          />
        </div>
      </div>
    </div>
  );
};
export default PaymentMethodFields;
